<template>
  <div v-if="items.length === 0" class="ren-decoration-cp ren-decoration-cp-order-card is-empty">
    暂无订单状态入口
  </div>
  <div v-else class="ren-decoration-cp ren-decoration-cp-order-card" :style="cardStyle">
    <span v-for="(item, index) in items" :key="itemKey(item, index)" class="order-card-item">
      <i class="order-card-icon" :style="iconBoxStyle(item, index)">
        <img v-if="itemIcon(item)" :src="itemIcon(item)" alt="" />
      </i>
      <b :style="labelStyle">{{ itemLabel(item) }}</b>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { numberValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const items = computed(() => {
  const raw = props.component.props?.statuses
  if (!Array.isArray(raw)) return []
  return raw
    .filter((item): item is Record<string, unknown> => Boolean(item && typeof item === 'object' && !Array.isArray(item)))
    .filter((item) => item.enabled !== false)
})

const cardStyle = computed(() => {
  const color = stringValue(props.component.style?.cardColor)
  return color ? { backgroundColor: color } : undefined
})

const labelStyle = computed(() => {
  const color = stringValue(props.component.style?.textColor)
  return color ? { color } : undefined
})

const iconSize = computed(() => Math.max(16, Math.round(numberValue(props.component.style?.iconSize, 30))))

function itemLabel(item: Record<string, unknown>) {
  return stringValue(item.label ?? item.title, '订单')
}

function itemIcon(item: Record<string, unknown>) {
  return stringValue(item.icon ?? item.imageUrl ?? item.image, '')
}

function iconBoxStyle(item: Record<string, unknown>, index: number) {
  const size = `${iconSize.value}px`
  const hasImage = Boolean(itemIcon(item))
  return {
    width: size,
    height: size,
    minWidth: size,
    background: hasImage
      ? 'transparent'
      : stringValue(item.backgroundColor) ||
        (Array.isArray(props.component.style?.iconPalette)
          ? String((props.component.style?.iconPalette as unknown[])[index % Math.max(1, (props.component.style?.iconPalette as unknown[]).length)] ?? '')
          : '') ||
        props.themeTokens?.primaryColor ||
        props.themeColor ||
        'var(--ren-theme-primary)',
    color: props.themeTokens?.buttonTextColor || '#fff'
  }
}

function itemKey(item: Record<string, unknown>, index: number) {
  return stringValue(item.key ?? item.id, `${itemLabel(item)}-${index}`)
}
</script>

<style scoped>
.ren-decoration-cp-order-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  border-radius: var(--ren-theme-radius, 8px);
  background: var(--ren-theme-card, #ffffff);
  padding: 12px 6px;
}

.ren-decoration-cp-order-card.is-empty {
  display: grid;
  min-height: 72px;
  place-items: center;
  color: var(--ren-theme-muted, #64748b);
  font-size: 12px;
}

.order-card-item {
  display: grid;
  flex: 1;
  justify-items: center;
  gap: 6px;
  min-width: 0;
}

.order-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: var(--ren-theme-radius, 8px);
  font-style: normal;
}

.order-card-icon img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.order-card-item b {
  overflow: hidden;
  color: var(--ren-theme-text, #17212b);
  font-size: 12px;
  font-weight: 500;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>